const roundNumber = (number, maxDecimalDigits = 2) => {
  return (
    Math.round((number || 0) * 10 ** maxDecimalDigits) / 10 ** maxDecimalDigits
  )
}
export default roundNumber
